import * as React from 'react';

const NotFoundScreen = () => <h1>404 - Page Not Found</h1>;

export default NotFoundScreen;
